import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ModalSizeE } from 'declarations/enums/modal';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import type { NoopT } from 'declarations/types/common';

import { getPopupContentStyle } from './DeleteAttachmentPopup.styled';
import useDeleteAttachmentPopup from './hooks/useDeleteAttachmentPopup';

type DeleteAttachmentPopupPropsT = {
  ticketId: string;
  fileName: string;
  originalName: string;
  isOpen: boolean;
  onClose: NoopT;
};

const DeleteAttachmentPopup: FC<DeleteAttachmentPopupPropsT> = ({
  ticketId,
  fileName,
  originalName,
  isOpen,
  onClose,
}) => {
  const { isMobile } = useResponsive();
  const { isDeletingAttachment, handleDeleteAttachment, handleClosePopup } =
    useDeleteAttachmentPopup();

  return (
    <Popup
      nested
      isOpen={isOpen}
      showCloseBtn
      modalTitle="Delete Attachment"
      size={ModalSizeE.DELETE_ATTACHMENT}
      popupId={ScrollLockIdE.DeleteAttachmentPopup}
      contentStyle={getPopupContentStyle(isMobile)}
      onClose={handleClosePopup(onClose)}
      closeOnEscape={false}
    >
      <Typography variant="body1" color="text.primary" align={isMobile ? 'center' : 'left'}>
        Are you sure you want to delete the attachment?
      </Typography>
      <Box display="flex" justifyContent={isMobile ? 'center' : 'flex-end'} sx={{ mt: 1 }}>
        <Button
          variant="contained"
          disabled={isDeletingAttachment}
          onClick={handleDeleteAttachment({ ticketId, fileName, originalName }, onClose)}
        >
          {isDeletingAttachment ? 'Deleting...' : 'Delete'}
        </Button>
      </Box>
    </Popup>
  );
};

export default DeleteAttachmentPopup;
